import { CreditDocument } from "@/core/entities/credit";
import { DeductionDocument } from "@/core/entities/deduction";

export const mapCreditDocumentsToViewerDocuments = (documents: CreditDocument[]): DeductionDocument[] => {
  return documents.map(
    document =>
      new DeductionDocument({
        id: document.id,
        fileName: document.fileName,
        fileSize: document.fileSize,
        createdAt: document.createdAt,
        updatedAt: document.updatedAt,
        documentType: document.documentType,
        documentTypeKey: document.documentTypeKey,
        fileMimeType: document.fileMimeType,
        fileDisplayName: document.fileDisplayName,
        filePath: document.filePath,
        signedUrl: document.signedUrl ?? "",
        deletable: document.deletable,
      })
  );
};
